import script from "./CategoryForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryForm.vue?vue&type=script&setup=true&lang=js"

import "./CategoryForm.vue?vue&type=style&index=0&id=8f4e229a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f4e229a"]])

export default __exports__